import { render, staticRenderFns } from "./MyFiles.vue?vue&type=template&id=ddd375f8&scoped=true"
import script from "./MyFiles.vue?vue&type=script&lang=js"
export * from "./MyFiles.vue?vue&type=script&lang=js"
import style0 from "./MyFiles.vue?vue&type=style&index=0&id=ddd375f8&prod&lang=scss"
import style1 from "./MyFiles.vue?vue&type=style&index=1&id=ddd375f8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddd375f8",
  null
  
)

export default component.exports